import {
  isMobile as _isMobile,
  isMobileOnly as _isMobileOnly,
  isTablet as _isTablet,
  isIOS,
  isMacOs,
  isSafari,
} from "react-device-detect";
import { useMediaQuery } from "./useMediaQuery";
import { useMemo } from "react";

const useDeviceMedia = (props = { min: "0px", max: "0px" }) => {
  const { min, max } = props;
  const isApple = useMemo(() => isIOS || isSafari || isMacOs, []);

  const isMobile = useMediaQuery("(max-width: 743px)");
  const isTablet = useMediaQuery("(max-width: 1199px)");
  const isTabletOnly = useMediaQuery("(min-width: 744px) and (max-width: 1199px)");
  const isLargeScreen = useMediaQuery("(max-width: 1399px)");
  const isLargeScreenOnly = useMediaQuery("(min-width: 1200px) and (max-width: 1399px)");
  const isAboveLargeScreen = useMediaQuery("(min-width: 1200px)");

  const isXLargeScreen = useMediaQuery("(max-width: 1599px)");
  const isXLargeScreenOnly = useMediaQuery("(min-width: 1400px) and (max-width: 1599px)");
  const isAboveXLargeScreen = useMediaQuery("(min-width: 1400px)");

  const isDesktopOnly = useMediaQuery("(min-width: 1600px)");
  const isCustomMin = useMediaQuery(`(min-width: ${min})`);
  const isCustomMax = useMediaQuery(`(max-width: ${max})`);

  return useMemo(() => ({
    isMobile,
    isTablet,
    isTabletOnly,
    isLargeScreen,
    isLargeScreenOnly,
    isXLargeScreen,
    isXLargeScreenOnly,
    isDesktopOnly,
    isCustomMin,
    isCustomMax,
    isAboveXLargeScreen,
    isAboveLargeScreen,
    isApple,
  }), [
    isMobile,
    isTablet,
    isTabletOnly,
    isLargeScreen,
    isLargeScreenOnly,
    isXLargeScreen,
    isXLargeScreenOnly,
    isDesktopOnly,
    isCustomMin,
    isCustomMax,
    isAboveXLargeScreen,
    isAboveLargeScreen,
    isApple,
  ]);
};

export default useDeviceMedia;
